import { useEffect, useState } from "react";
import { Globe, X } from "lucide-react";

const COPY = {
  en: {
    msg: "Would you like to view this page in English?",
    yes: "Yes, translate",
    no: "No, thanks",
  },
  pt: {
    msg: "Gostaria de ver esta página em português?",
    yes: "Sim, traduzir",
    no: "Não, obrigado",
  },
};

// Detect navigator base language code (en, pt, es, ...).
const detectBrowserLang = () => {
  if (typeof navigator === "undefined") return null;
  const codes = navigator.languages && navigator.languages.length
    ? navigator.languages
    : [navigator.language || ""];
  for (const c of codes) {
    const base = String(c).toLowerCase().split("-")[0];
    if (base === "en" || base === "pt") return base;
  }
  return null;
};

const applyLanguage = (code) => {
  const host = window.location.hostname;
  const cookie = code === "es" ? "" : `/es/${code}`;
  const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `googtrans=${cookie};path=/;expires=${expires}`;
  document.cookie = `googtrans=${cookie};domain=${host};path=/;expires=${expires}`;
  document.cookie = `googtrans=${cookie};domain=.${host.replace(/^www\./, "")};path=/;expires=${expires}`;
  try { localStorage.setItem("cv_lang", code); } catch { /* noop */ }
  window.location.reload();
};

const LanguagePromptBanner = () => {
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState("en");

  useEffect(() => {
    try {
      // Don't show if user already picked, dismissed, or is already in non-es lang
      if (localStorage.getItem("cv_lang")) return;
      if (localStorage.getItem("cv_prompt_dismissed")) return;
      const lang = detectBrowserLang();
      if (!lang) return;
      setTarget(lang);
      // small delay so it doesn't flash on every navigation
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    } catch { /* noop */ }
  }, []);

  if (!show) return null;
  const t = COPY[target];

  const accept = () => applyLanguage(target);
  const decline = () => {
    try { localStorage.setItem("cv_prompt_dismissed", "1"); } catch { /* noop */ }
    setShow(false);
  };

  return (
    <div
      data-testid="lang-prompt-banner"
      className="notranslate fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] max-w-[95vw] w-[420px] bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl shadow-2xl p-4 flex items-start gap-3"
      translate="no"
    >
      <div className="w-9 h-9 rounded-lg bg-[#45A0EE]/10 text-[#45A0EE] flex items-center justify-center flex-shrink-0">
        <Globe className="h-4 w-4" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-[#1D1D1B] dark:text-white">
          {t.msg}
        </p>
        <div className="mt-2 flex gap-2">
          <button
            type="button"
            onClick={accept}
            data-testid="lang-prompt-accept"
            className="bg-[#45A0EE] hover:bg-[#3590de] text-white text-xs font-bold px-3 py-1.5 rounded-lg transition-colors"
          >
            {t.yes}
          </button>
          <button
            type="button"
            onClick={decline}
            data-testid="lang-prompt-decline"
            className="bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors"
          >
            {t.no}
          </button>
        </div>
      </div>
      <button
        type="button"
        onClick={decline}
        aria-label="Cerrar"
        className="text-slate-400 hover:text-slate-700 dark:hover:text-white p-1"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default LanguagePromptBanner;
